<template>
<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-color-vector`]" width="1em" height="1em" v-bind="$attrs"><path d="M7.73676 1.02832C7.85234 0.828844 8.14079 0.828742 8.25629 1.02832L10.81 5.45215C10.9252 5.65207 10.781 5.90124 10.5502 5.90137H8.66156V9.49707H7.33441V11.2217H8.66449V9.51074L14.0375 8.07129C14.392 7.97656 14.7568 8.18761 14.852 8.54199C14.9469 8.89649 14.7366 9.26114 14.3823 9.35645L10.5698 10.377L14.3823 11.3994C14.7365 11.4947 14.9476 11.8595 14.853 12.2139C14.7579 12.5681 14.3929 12.778 14.0385 12.6836L8.66156 11.2422V14.7578C8.66141 15.1248 8.36354 15.4227 7.99652 15.4229C7.6294 15.4228 7.33163 15.1249 7.33148 14.7578V11.2451L1.96234 12.6836C1.60776 12.7783 1.24292 12.5684 1.14789 12.2139C1.0531 11.8593 1.26412 11.4945 1.61859 11.3994L5.43207 10.377L1.61859 9.35547C1.26398 9.26031 1.05383 8.89569 1.14886 8.54102C1.24436 8.18689 1.60891 7.97633 1.96332 8.07129L7.33148 9.50977V5.90137H5.44281C5.21194 5.90137 5.06778 5.65212 5.18304 5.45215L7.73676 1.02832Z" :fill="useCurrentColor ? 'currentColor' : '#0AA5A8'"/></svg>
</template>
<script>

export default {
  name: 'IconColorVector',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
